import { useAnim, useSEO } from "../hooks.jsx";
import { Link } from "react-router-dom";
import { GUIDES, PAGE_SEO, breadcrumb } from "../data.js";
import CtaBand from "../components/CtaBand.jsx";
import Breadcrumb from "../components/Breadcrumb.jsx";

const RIGHE = [
  { a: "Ricezione prenotazioni", excel: "Telefono, WhatsApp, email — canali separati", gest: "Sito online 24/7 + inserimento manuale, tutto sullo stesso calendario" },
  { a: "Controllo disponibilità", excel: "A vista, controllando manualmente il foglio", gest: "Aggiornata in automatico ad ogni prenotazione" },
  { a: "Rischio doppia prenotazione", excel: "Concreto se più operatori o canali", gest: "Eliminato: il veicolo si blocca da solo" },
  { a: "Contratti", excel: "Compilati a mano da un modello Word", gest: "PDF generato automaticamente dai dati della prenotazione" },
  { a: "Pagamenti", excel: "Contanti o bonifico, tracciati a mano", gest: "Carta online integrata, tracciata automaticamente" },
  { a: "Statistiche e ricavi", excel: "Calcolate a mano, se avanza tempo", gest: "Dashboard sempre aggiornata" },
  { a: "Più operatori insieme", excel: "Rischio di modifiche in conflitto sullo stesso file", gest: "Ognuno vede lo stato reale in tempo reale" },
  { a: "Immagine verso il cliente", excel: "Nessun sito, si passa da messaggi privati", gest: "Sito professionale con il tuo brand" },
  { a: "Tenuta alla crescita", excel: "Regge con pochi veicoli, poi diventa ingestibile", gest: "Stessa gestione con 5 o 50 veicoli" },
];

const BC_ITEMS = [{ name: "Excel/WhatsApp o gestionale", path: "/excel-whatsapp-o-gestionale-autonoleggio" }];

export default function ExcelWhatsappOGestionale({ go }) {
  useAnim();
  useSEO({
    ...PAGE_SEO["excel-whatsapp-o-gestionale-autonoleggio"],
    schema: breadcrumb(BC_ITEMS),
  });

  return (
    <>
      <Breadcrumb items={BC_ITEMS} />
      <section className="ph">
        <div className="ph-in an">
          <div className="chip">Confronto</div>
          <h1 className="h2" style={{ fontSize: "clamp(1.9rem,4vw,2.9rem)" }}>
            Excel e WhatsApp <mark>o un gestionale</mark>
          </h1>
          <p className="lead" style={{ marginTop: ".65rem" }}>
            Attività per attività, cosa cambia davvero nella gestione
            quotidiana di un autonoleggio.
          </p>
        </div>
      </section>

      <section className="sec" style={{ background: "var(--bg)" }}>
        <div className="wrap" style={{ maxWidth: 900 }}>
          <div className="an" style={{ overflowX: "auto", marginBottom: "2.5rem" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: ".9rem" }}>
              <thead>
                <tr style={{ textAlign: "left", borderBottom: "2px solid var(--border, #e6e9f0)" }}>
                  <th style={{ padding: ".8rem .6rem" }}>Attività</th>
                  <th style={{ padding: ".8rem .6rem" }}>Con Excel / WhatsApp</th>
                  <th style={{ padding: ".8rem .6rem" }}>Con un gestionale</th>
                </tr>
              </thead>
              <tbody>
                {RIGHE.map((r) => (
                  <tr key={r.a} style={{ borderBottom: "1px solid var(--border, #eef0f5)" }}>
                    <td style={{ padding: ".8rem .6rem", fontWeight: 600 }}>{r.a}</td>
                    <td style={{ padding: ".8rem .6rem", color: "var(--muted)" }}>{r.excel}</td>
                    <td style={{ padding: ".8rem .6rem", color: "var(--muted)" }}>{r.gest}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="an" style={{ padding: "1.5rem", borderRadius: 14, background: "var(--bg2, #f6f8fc)" }}>
            <h2 style={{ fontSize: "1.15rem", marginBottom: ".5rem" }}>
              Il passaggio non richiede di fermarsi
            </h2>
            <p style={{ fontSize: ".95rem", color: "var(--muted)", lineHeight: 1.75, marginBottom: ".75rem" }}>
              Puoi caricare la flotta su NoleggioinCloud e affiancare per un
              po' il vecchio metodo, finché non ti senti sicuro a passare del
              tutto al nuovo sito di prenotazione.
            </p>
            <Link to="/come-funziona" style={{ fontWeight: 600 }}>
              Vedi come funziona il passaggio →
            </Link>
          </div>

          <div className="an" style={{ marginTop: "2rem" }}>
            <h2 style={{ fontSize: "1.05rem", marginBottom: ".5rem" }}>Approfondisci</h2>
            <ul style={{ paddingLeft: "1.1rem", color: "var(--muted)", fontSize: ".95rem", lineHeight: 2 }}>
              {GUIDES.filter((g) => g.slug !== "excel-whatsapp-o-gestionale-autonoleggio").map((g) => (
                <li key={g.slug}>
                  <Link to={`/${g.slug}`}>{g.label}</Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <CtaBand go={go} />
    </>
  );
}
